import { debounce } from "../../util/dom";
import { getCookie, setCookie } from "../../util/dom";
var messageBarCookie = 'message-bar-closed';
var hideMessageBar = false;
var messageBar = function messageBar() {
  var header = document.getElementById('js-header');
  if (header.classList.contains('has-message')) {
    document.body.classList.add('has-messageBar');
  } else {
    return;
  }
  var headerHeight = header.offsetHeight;
  if (document.body.classList.contains('admin-bar')) {
    if (matchMedia('screen and (min-width: 783px)').matches) {
      headerHeight + 32;
    } else {
      headerHeight + 46;
    }
  }
  var messageBar = document.querySelector('.message-bar');
  var messageBarClose = document.querySelector('.js-message-bar-close');
  var searchBar = document.querySelector('.js-search-bar');
  if (!searchBar) {
    return;
  }
  document.body.style.paddingTop = headerHeight + 'px';
  searchBar.style.paddingTop = headerHeight + 'px';
  messageBarClose.addEventListener('click', function () {
    messageBar.classList.add('d-none');
    header.classList.remove('has-message');
    document.body.classList.remove('has-messageBar');
    if (!hideMessageBar) setCookie(messageBarCookie, true, 1, 'SameSite=None; Secure');
    updateContentPadding();
  });
  $(window).on("store.setCountry", function () {
    renderMessage();
  });
  window.addEventListener('resize', debounce(function () {
    var header = document.getElementById('js-header');
    var headerHeight = header.offsetHeight;
    if (document.body.classList.contains('admin-bar')) {
      if (matchMedia('screen and (min-width: 783px)').matches) {
        headerHeight + 32;
      } else {
        headerHeight + 46;
      }
    }
    document.body.style.paddingTop = headerHeight + 'px';
    searchBar.style.paddingTop = headerHeight + 'px';
  }, 200));
};
var updateContentPadding = function updateContentPadding() {
  var header = document.getElementById('js-header');
  var searchBar = document.querySelector('.js-search-bar');
  var headerHeight = header.offsetHeight;

  // messageBar.classList.add('d-none');
  // header.classList.remove('has-message');
  // document.body.classList.remove('has-messageBar');

  if (document.body.classList.contains('admin-bar')) {
    if (matchMedia('screen and (min-width: 783px)').matches) {
      headerHeight + 32;
    } else {
      headerHeight + 46;
    }
  }
  document.body.style.paddingTop = headerHeight + 'px';
  if (searchBar) searchBar.style.paddingTop = headerHeight + 'px';
};
var renderMessage = function renderMessage() {
  var headroomMessage = document.getElementsByClassName('js-headroom-message');
  console.log('render messageBar');
  if (headroomMessage.length === 0) {
    return;
  }
  if (document.body.classList.contains('template-checkout')) return;
  var store = getCookie("esc_store", true);
  hideMessageBar = false;
  for (var i = 0; i < headroomMessage.length; i++) {
    var element = headroomMessage[i];
    var messages = JSON.parse(element.dataset.messages);
    var newContent = {};
    var overrideContent = false;
    if (typeof messages[store.country] !== 'undefined') {
      newContent = messages[store.country];
      overrideContent = true;
    }
    element.classList.remove('d-none');
    updateContentPadding();

    // Update Headroom title and text
    var title = updateEl(element.querySelector('.js-message--title'), newContent.title, overrideContent);
    var text = updateEl(element.querySelector('.js-message--text'), newContent.message, overrideContent);

    // Close message bar if no content
    if (!title && !text || getCookie(messageBarCookie, true)) {
      if (!title && !text) hideMessageBar = true;
      element.querySelector('.js-message-bar-close').click();
    }
  }
};
var updateEl = function updateEl(el, content, override) {
  if (!el) return;
  if (override) {
    el.classList.add('d-none');
    el.innerHTML = content;
    if (content) el.classList.remove('d-none');
  }
  return el.innerHTML;
};
export { renderMessage };
export default messageBar;


// WEBPACK FOOTER //
// ./scripts/partials/top/message-bar.js